<div class="spinner">
  <img [src]="loadingImg" alt="Loading..." height="100px;"/>
</div>
